module.exports = __webpack_public_path__ + "img/map-fr.c6a307a5.png";